<!-- <div class="hra-caontainer">
<div class="hra-main">
  <div class="_w-section-left">
    <div class="_w-hra-content">
      <h2 class="_w-hra-heading">Complete Your Health Risk Assessment</h2>
      <p class="_w-hra-text">Take a comprehensive review of your health!</p>
    </div>
    <div class="_w-hra-cta-container">
      <a href="" class="health_btn w-button">Take HRA</a>
    </div>
  </div>
  <div class="_w-section-left">
    <img src="assets/images/wellness-app/images/HRA Status.png" class="_w-hra-icon">
  </div>
</div>
</div> -->
@if (!showSkeletonLoader) {
  <div class="hra-caontainer">
    <div class="assessment_outer">
      <div class="assessment_block txt">
        <h3 class="assessment_title">Complete Your Health Risk Assessment</h3>
        <p class="paragraph-46">Take a comprehensive review of your health!</p>
        <a class="health_btn w-button" (click)="handleLinkClick()">Take HRA</a>
      </div>
      <div class="assessment_block">
        <div class="download_report_container">
          <div class="download_report_outer">
            <div class="download_report_inner" (click)="downloadReport()">
              <div class="dr_text">Your HRA Status</div>
              <div class="dr_hra_status medium">{{config['innerData']!=undefined && config['innerData'].final_score_text!=undefined && config['innerData'].final_score_text?config['innerData'].final_score_text:''}}</div>
              <div class="dr_hra_icon"><i class="fa fa-download" aria-hidden="true"></i></div>
            </div>
          </div>
        </div>
        <!-- <img loading="lazy" src="assets/images/wellness-app/images/HRA Status.png" alt="" class="image-12204" (click)="downloadReport()"> -->
      </div>
    </div>
  </div>
}
@if (showSkeletonLoader) {
  <app-skeleton-loader  [height]="height"></app-skeleton-loader>
}